<template>
  <MW2023Background>
    <div v-if="isRoute === '2'" class="min-h-[80vh] flex justify-center py-10">
      <MWForm class="text-sm text-white" />
    </div>

    <div
      v-else
      class="relative min-h-[80vh] flex flex-col justify-center items-center gap-3 text-white"
    >
      <font-awesome-icon
        icon="fa-solid fa-screwdriver-wrench"
        class="text-8xl"
      />
      <p>Уучлаарай, хуудас түр засвартай байна.</p>
    </div>
  </MW2023Background>
</template>

<script>
import MW2023Background from "@/components/MiningWeek/MW2023/MW2023Background";
import MWForm from "./MW2023Form.vue";
import { watch, ref, onMounted } from "vue";
import { useRoute } from "vue-router";

export default {
  name: "MW2023StaticPage",
  components: {
    MW2023Background,
    MWForm,
  },
  setup() {
    const route = useRoute();
    const isRoute = ref(null);

    onMounted(() => {
      isRoute.value = route.params.cid;
    });

    watch(
      () => route.params.cid,
      (newCid) => {
        isRoute.value = newCid;
      }
    );

    return { isRoute };
  },
};
</script>
